import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from 'src/utils/axios';
import parseQueryParams from '../../../utils/query';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  isContactListReady: false,
  error: false,
  contactList: [],
  contact: {},
};

const slice = createSlice({
  name: 'Contacts',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET Form List
    getContactListSuccess(state, action) {
      state.isLoading = false;
      state.isContactListReady = true;
      state.contactList = action.payload;
    },

    getContactSuccess(state, action) {
      state.isLoading = false;
      state.contact = action.payload;
    },

    resetContactList(state) {
      state.isContactListReady = false;
      state.contactList = [];
    },
  },
});

//Actions
export const { resetContactList } = slice.actions;

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getContactListByHousehold(
  household_id,
  property_id,
  queryParams,
  certification_id
) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      // ULHHM v2-only certs have no legacy household. Scope by certification
      // (backend ContactFilter.filter_certification resolves the cert's
      // CertHousehold and returns its contacts + property-level contacts)
      // instead of falling back to an unscoped property-wide query that leaks
      // every other cert's household contacts.
      const scopeParam = household_id
        ? `household=${household_id}`
        : certification_id
        ? `certification=${certification_id}`
        : '';
      const response = await axios.get(
        `contacts/?${scopeParam}&property=${property_id}&${parseQueryParams(
          queryParams
        )}`
      );
      dispatch(slice.actions.getContactListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getContact(contactId, queryParams) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `contacts/${contactId}/?${parseQueryParams(queryParams)}`
      );
      dispatch(slice.actions.getContactSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
